import { Injectable, inject } from "@angular/core";
import { IFeature } from "@shared/components/interfaces/feature.interface";
import { CustomRendererService } from "@shared/services/custom-renderer.service";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { FeatureStoreService } from "@shared/services/feature-store/feature-store.service";
import { Observable, catchError, map, of } from "rxjs";
import { AppConstants } from "@core/constants";

@Injectable({
  providedIn: 'root'
})
export class MetricSettingsResolver {
  private snackBar: MatSnackBar = inject(MatSnackBar);
  private customRendererService: CustomRendererService = inject(CustomRendererService);

  private readonly featureService: FeatureStoreService = inject(FeatureStoreService);

  public resolve(): Observable<IFeature[] | null> {
    return this.featureService.getFeatureList()
      .pipe(
        map((response: any) => response?.results || []),
        catchError(error => {
          this.customRendererService.hide(AppConstants.MAT_SPINNER_CLASS);
          this.snackBar.open(error, 'OK', AppConstants.TOAST_CONFIG.ERROR);
          return of(null);
        })
      )
  }
}